export function getColors(colors) {
  return colors ? colors.split(',') : []
}
